import { useState, useCallback } from 'react';

export const useTabNavigation = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [visitedTabs, setVisitedTabs] = useState<Set<number>>(new Set([0]));

  const handleTabChange = useCallback((_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setVisitedTabs(prev => new Set([...prev, newValue]));
  }, []);

  return {
    activeTab,
    visitedTabs,
    handleTabChange
  };
};